<template>
  <!-- START NAV -->
  <nav
    class="navbar flex"
    role="navigation"
  >
    <div class="navbar-brand w-full lg:w-auto">
      <router-link
        v-if="$root.goBackLink === null"
        class="navbar-item navbar-logo"
        to="/"
      >
        Self Storage Solution
      </router-link>
      <a
        v-else
        class="navbar-item"
        title="Go back"
        style="transform: rotate(180deg); font-size: 1.5em"
        @click="handleBackStep()"
      >&#10140;</a>

      <template v-if="$store.state.organizations.length">
        <!-- @todo refactor -->
        <div
          v-if="$store.state.organizations.length === 1"
          class="navbar-item"
        >
          <span class="w-32 truncate">
            {{ getOrganizationName() }}
          </span>
        </div>
        <div
          v-else
          class="navbar-item dropdown navbar-company"
        >
          <div class="navbar-link flex">
            <div class="truncate">
              {{ getOrganizationName() }}
            </div>
          </div>

          <div class="navbar-dropdown is-hidden-touch organizations">
            <template v-for="(organization) in $store.state.organizations">
              <button
                :key="organization.uuid + Math.random()"
                class="navbar-item menu-button"
                @click="(e) => selectOrganization(e, organization)"
              >
                {{ organization.name }}
              </button>
            </template>
          </div>
        </div>
      </template>

      <a
        ref="navMenuButton"
        role="button"
        aria-label="menu"
        aria-expanded="false"
        class="navbar-burger burger"
        data-target="navMenu"
        @click="showMenu"
      >
        <span aria-hidden="true" />
        <span aria-hidden="true" />
        <span aria-hidden="true" />
      </a>
    </div>
    <div
      id="navMenu"
      ref="navMenu"
      class="navbar-menu absolute right-0 top-14 lg:top-0 lg:relative w-full lg:w-auto lg:flex"
    >
      <div
        v-if="$root.showNavigation"
        class="navbar-start lg:items-center lg:mx-auto lg:flex lg:justify-around"
      >
        <router-link
          v-if="isRouteVisible(routes.DASHBOARD, role)"
          class="navbar-item"
          :to="routes.DASHBOARD.path"
          :class="isRouteActive(routes.DASHBOARD, currentPage) ? 'is-active' : ''"
          @click.native="hideMenu()"
        >
          <span>Main Dashboard</span>
        </router-link>
        <router-link
          v-if="isRouteVisible(routes.WORKFLOW, role)"
          class="navbar-item"
          :to="routes.WORKFLOW.path"
          :class="isRouteActive(routes.WORKFLOW, currentPage) ? 'is-active' : ''"
          @click.native="hideMenu()"
        >
          <span>Workflow</span>
        </router-link>
        <router-link
          v-if="isRouteVisible(routes.TEMPLATE, role)"
          class="navbar-item"
          :to="routes.TEMPLATE.path"
          :class="isRouteActive(routes.TEMPLATE, currentPage) ? 'is-active' : ''"
          @click.native="hideMenu()"
        >
          <span>Template</span>
        </router-link>
        <router-link
          v-if="isRouteVisible(routes.TEAM, role)"
          class="navbar-item"
          :to="routes.TEAM.path"
          :class="isRouteActive(routes.TEAM, currentPage) ? 'is-active' : ''"
          @click.native="hideMenu()"
        >
          <span>Team</span>
        </router-link>
        <router-link
          v-if="isRouteVisible(routes.COMPANY, role)"
          class="navbar-item"
          :to="routes.COMPANY.path"
          :class="isRouteActive(routes.COMPANY, currentPage)
            ? 'is-active' : ''"
          @click.native="hideMenu()"
        >
          <span>Company</span>
        </router-link>
        <router-link
          v-if="isRouteVisible(routes.COMPANIES, role)"
          class="navbar-item"
          :to="routes.COMPANIES.path"
          :class="isRouteActive(routes.COMPANIES, currentPage)
            ? 'is-active' : ''"
          @click.native="hideMenu()"
        >
          <span>Companies</span>
        </router-link>
        <router-link
          v-if="isRouteVisible(routes.REPORTS, role)"
          class="navbar-item"
          :to="routes.REPORTS.path"
          :class="isRouteActive(routes.REPORTS, currentPage)
            ? 'is-active' : ''"
          @click.native="hideMenu()"
        >
          <span>Report</span>
        </router-link>
      </div>

      <div
        class="navbar-item cursor-pointer hover:text-primary transition-colors duration-300"
        @click="faqHandler"
      >
        <span>Help Center</span>
      </div>

      <div class="lg:hidden h-px my-8 bg-gray-200 border-0 dark:bg-muted-700" />

      <div class="navbar-end">
        <div class="navbar-item has-dropdown is-hoverable">
          <a class="navbar-link is-hidden-touch lg:pr-4">
            {{ $store.state.user.firstname }} {{ $store.state.user.lastname }}
          </a>

          <div class="navbar-dropdown is-right">
            <hr class="navbar-divider is-hidden-desktop">
            <button
              v-if="$store.state.organizations.length > 1"
              class="menu-button navbar-item is-hidden-desktop"
              @click="handleSwitchLocationsClick()"
            >
              <i class="fas fa-random fa-fw" /> Switch Location
            </button>
            <router-link
              v-if="isAdmin || role === roles.CS_ADMIN"
              to="/doc-upload"
              class="navbar-item"
            >
              <i class="fas fa-file-upload" /> Control Panel
            </router-link>
            <router-link
              to="/user/profile"
              class="navbar-item"
              @click.native="hideMenu()"
            >
              <i class="fas fa-user fa-fw" /> My profile
            </router-link>
            <div
              class="navbar-item cursor-pointer"
              @click="helpCenterHandler"
            >
              <i class="fas fa-info-circle" /> Help center
            </div>
            <div
              class="navbar-item logout text-red-600 cursor-pointer"
              @click="logout"
            >
              <i class="fas fa-power-off fa-fw" /> Logout
            </div>
            <!--<a class="navbar-item">
                                Jobs
                            </a>
                            <a class="navbar-item">
                                Contact
                            </a>
                            <hr class="navbar-divider">
                            <a class="navbar-item">
                                Report an issue
                            </a>-->
          </div>
        </div>
      </div>
    </div>
  </nav>
  <!-- END NAV -->
</template>

<script>
import { Routes, Roles } from '../constants';
import { isRouteVisible, isRouteActive } from '../utils/routeUtils';
import DashboardService from '../services/dashboard.service';
import WorkflowService from '../services/workflow.service';
import UserService from '../services/user.service';

const workflowService = new WorkflowService();
const dashboardService = new DashboardService();
const userService = new UserService();

export default {
  name: 'HeaderComponent',
  data() {
    return {
      isRouteVisible: (route, role) => isRouteVisible(route, role),
      isRouteActive: (route, currentPage) => isRouteActive(route, currentPage),
      routes: Routes,
      role: this.$store.state.user.role,
      isAdmin: this.$store.state.user.role === Roles.SUPER_ADMIN,
      roles: Roles,
      routesForCheck: [Routes.WORKFLOW_EDIT.name, Routes.PROFILE.name]
    };
  },
  computed: {
    currentPage() {
      return this.$route.path;
    }
  },
  methods: {
    handleBackStep() {
      window.history.back();
    },
    handleSwitchLocationsClick(e) {
      e?.preventDefault();
      this.$root.showCompanies = true;
      this.hideMenu();
      this.$router.push({ name: 'login' });
    },
    faqHandler(e) {
      e.preventDefault();
      userService.getZendeskFaqLink().then((res) => {
        const { data } = res;
        if (data?.status === 'success') {
          window.open(data.result?.link);
        }
      }).catch(() => {
        // eslint-disable-next-line no-restricted-globals
        self.$root.$emit('showToast', { message: 'Impossible to find your location info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
      });
    },
    helpCenterHandler(e) {
      e.preventDefault();
      userService.getZendeskHelpCenterLink().then((res) => {
        const { data } = res;
        if (data?.status === 'success') {
          window.open(data.result?.link);
        }
      }).catch(() => {
        // eslint-disable-next-line no-restricted-globals
        self.$root.$emit('showToast', { message: 'Impossible to find your location info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
      });
    },
    logout(e) {
      e.preventDefault();
      if (this.routesForCheck.includes(this.$route.name)) {
        this.$store.commit('setShouldLogout', true);
        this.$router.push({ name: 'login' });
        return;
      }
      const self = this;
      this.$store.dispatch('logout', () => { self.$router.push({ name: 'login' }); });
    },
    showMenu(e) {
      e.preventDefault();
      const target = document.querySelector(`#${e.currentTarget.dataset.target}`);
      e.currentTarget.classList.toggle('is-active');
      target.classList.toggle('is-active');
    },
    hideMenu() {
      const menu = this.$refs.navMenu;
      const button = this.$refs.navMenuButton;

      if (menu?.classList.contains('is-active')) {
        menu.classList.remove('is-active');
      }

      if (button?.classList.contains('is-active')) {
        button.classList.remove('is-active');
      }
    },
    selectOrganization(e, organization) {
      e.preventDefault();
      organization = { ...organization };

      if (organization && Object.keys(organization).length) {
        this.getLocations(this.$store.state.user.role, organization.uuid);
        this.$store.commit('setOrganization', { organization });
      }
    },
    getLocations(role, organizationUuid) {
      const self = this;
      userService.getLocations(role, organizationUuid)
        .then((resp) => {
          const locationsData = resp.data;
          const { status: locationStatus, result: locationsResult } = locationsData;

          if (locationStatus === 'success') {
            self.locationList = locationsResult;
            self.$store.commit('setLocationsList', locationsData);
            // only one location in the list ? user doesn't have to choose
            if (locationsResult?.length) {
              self.setEmployeeData(locationsResult[0].uuid);
            } else {
              self.handleRedirect();
            }
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to find your location info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Impossible to find your location info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    handleRedirect() {
      const { path, name } = this.routes.DASHBOARD;
      const isDashboardActive = this.$route.path === path;

      if (isDashboardActive) {
        window.location.reload();
        return;
      }
      this.$router.push({ name });
    },
    setEmployeeData(uuid) {
      const self = this;

      // getting employee data (user, company, rights) and storing it
      dashboardService.getEmployeeCompany(uuid)
        .then((response) => {
          const { data } = response;

          if (data.status === 'success') {
            self.$store.commit('setEmployeeData', response.data);

            workflowService.getWorkflowList(uuid)
              .then((resp) => {
                const { status, result } = resp.data;

                self.$store.commit('setAccountReady', (status === 'success' && result.list.length));
                self.handleRedirect();
              })
              .catch(() => {
                self.$store.commit('setAccountReady', false);
                self.handleRedirect();
              });
          } else {
            self.$root.$emit('showToast', { message: 'Impossible to find your employee info. Please try later or complete your profile', options: { cssClass: 'is-danger', duration: 10000 } });
          }
        })
        .catch(() => {
          self.$root.$emit('showToast', { message: 'Technical issue. Please try again later', options: { cssClass: 'is-danger', duration: 10000 } });
        });
    },
    getOrganizationName() {
      return this.$store.state.organization ? this.$store.state.organization.name : '';
    }
  }
};
</script>

<style scoped lang="scss">

    .navbar-item {
        i.fas {
            margin-right: 10px;
        }
    }

    @media screen and (max-width: 1024px){
        .navbar-company {
            .navbar-link {
                pointer-events: none;

                &:after {
                    display: none;
                }
            }
        }
    }

    .navbar-link.pr-0 {
      padding: inherit;
      max-width: 70vw;

      @screen lg {
        max-width: 150px;

        div {
          padding-right: 12px;
        }
      }
    }

    .navbar-company {
        .navbar-dropdown {
            max-height: 350px;
            overflow-y: auto;
        }
    }

    .organizations {
        padding: 15px;
    }

    .menu-button {
        border: none;
        outline: none;
        background: none;
        width: 100%;
        cursor: pointer;

        &:hover {
          @apply
            bg-muted-200
            dark:bg-muted-600;
        }

        &.is-hidden-desktop {
            text-align: left;
        }
    }
</style>
